export default __webpack_public_path__ + "static/media/aircare-poster-3.7aab2c26.jpg";